module.exports = __webpack_public_path__ + "e6f1286801a1f57b16cceb2d0c76d744.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/building.svg
// module id = 736
// module chunks = 0